/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-document': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.063 5.813l-4.375-4.375a.569.569 0 00-.438-.188H5c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.25a.569.569 0 00-.188-.438zM11.25 2.75l3.5 3.5h-3.5v-3.5zM15 17.5H5v-15h5v3.75c0 .69.56 1.25 1.25 1.25H15v10zm-8.125-3.75h6.25V15h-6.25v-1.25zm0-3.75h6.25v1.25h-6.25V10z"/>'
  }
})
